import { useState } from 'react';
import ManifestItem from 'components/ManifestItem/ManifestItem';
import { Dimmer, Loader, Message, Table } from 'semantic-ui-react';

export default function ManifestsList({ manifests, loading }) {
  const [printing, setPrinting] = useState(false);

  return (
    <>
      <Dimmer
        active={loading}
        inverted
        role="dialog"
        aria-describedby="loading-manifests-loader"
      >
        <Loader id="loading-manifests-loader">Recuperando manifiestos…</Loader>
      </Dimmer>
      <Dimmer
        active={printing}
        inverted
        role="dialog"
        aria-describedby="printing-manifest-loader"
      >
        <Loader id="printing-manifest-loader">
          Imprimiendo manifiesto y etiqueta de pallet…
        </Loader>
      </Dimmer>
      {!!manifests?.length ? (
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Referencia</Table.HeaderCell>
              <Table.HeaderCell textAlign="center">
                Núm. bultos
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="right">Imprimir</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {manifests.map((manifest, index) => (
              <ManifestItem
                key={index}
                manifest={manifest}
                setPrinting={setPrinting}
              />
            ))}
          </Table.Body>
        </Table>
      ) : (
        <Message info>No hay manifiestos generados</Message>
      )}
    </>
  );
}
